import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfiguratorEnvironment, ConfigurationType } from './configurations.types';

/**
 * Interface dla ConfigurationsService - używany przez price services
 * aby uniknąć circular dependencies między @icc/price a @icc/configurator/shared
 */
export interface IConfigurationsService<T extends ConfigurationType = ConfigurationType> {
    conf: ConfiguratorEnvironment<T>;
    conf$: BehaviorSubject<Partial<ConfiguratorEnvironment<T>>>;
    configuration$: Observable<any>;
    price: any;

    /**
     * Tworzy Simple Configuration używając Registry
     */
    createSimpleConfiguration(
        configuration: any,
        dataRequiredForUpdate?: any,
        configuratorsDataService?: any,
        langCode?: string,
        config?: any
    ): any;
}

/**
 * Injection token dla ConfigurationsService
 */
export const CONFIGURATIONS_SERVICE = new InjectionToken<IConfigurationsService>(
    'ConfigurationsService'
);
